import React from 'react';
import { AlertCircleIcon, CheckIcon, StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { plans } from '../data/content';
export function PricingSection() {
  return <section id="pricing" aria-labelledby="precios" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10" data-id="element-203" data-mp="1egnuc4uy4ayv">
      <Reveal className="flex flex-col items-center gap-2 text-center" data-id="element-204" data-mp="1nakcz9owj59j">
        <span className="inline-flex w-fit items-center gap-2 rounded-lg bg-danger-soft px-3 py-1.5 text-xs font-bold uppercase tracking-wide text-danger" data-id="element-205" data-mp="1naam7jw18u2s">
          <AlertCircleIcon size={14} data-id="element-206" data-mp="1x8gklrimri2w" />
          Oferta de lanzamiento — precio promocional por tiempo limitado
        </span>
        <h2 id="precios" className="font-display text-2xl md:text-3xl font-extrabold uppercase text-ink" data-id="element-207" data-mp="227b28q4v30lf">
          Elegí tu Mega Pack
        </h2>
        <p className="max-w-3xl text-sm md:text-base text-ink-muted" data-id="element-208" data-mp="7t0g4pfnikjc">
          Comprando cursos, manuales y recursos por separado te costaría mucho
          más. Durante esta promoción accedés al sistema completo a un precio
          especial.
        </p>
      </Reveal>

      <div className="mt-6 grid gap-4 lg:grid-cols-2 lg:items-start" data-id="element-209" data-mp="1cqlnjga7i5on">
        {plans.map((plan, i) => <Reveal key={plan.id} delay={i * 0.05} className={`flex h-full flex-col rounded-2xl p-6 ${plan.recommended ? 'border-2 border-accent bg-surface' : 'border border-line bg-surface'}`} data-id="element-210" data-mp="17saeh7rqjz7h" data-mpi={i}>
            {plan.recommended ? <span className="mb-3 inline-flex w-fit items-center gap-1.5 rounded-lg bg-accent px-3 py-1 font-display text-xs font-black uppercase tracking-wide text-canvas" data-id="element-211" data-mp="1vg1t4i0r0obx">
                <StarIcon size={12} className="fill-canvas" data-id="element-212" data-mp="k2g0gmvok4ln" />
                Recomendado
              </span> : <span className="mb-3 inline-flex w-fit items-center rounded-lg bg-surface-alt px-3 py-1 font-display text-xs font-bold uppercase tracking-wide text-ink-muted" data-id="element-213" data-mp="fz1bh6prkdw2">
                Mega Pack
              </span>}

            <h3 className={`font-display text-xl md:text-2xl font-extrabold uppercase leading-tight ${plan.recommended ? 'text-accent' : 'text-ink'}`} data-id="element-214" data-mp="7jlugpvh89n1">
              {plan.name}
            </h3>
            <p className="mt-1.5 text-sm text-ink-muted" data-id="element-215" data-mp="3uvwbf0wglfbv">{plan.audience}</p>

            <ul className="mt-4 grid gap-1.5 sm:grid-cols-2" data-id="element-216" data-mp="3i8jy2hfvi9s">
              {plan.features.map(feature => <li key={feature} className="flex items-start gap-2 text-sm text-ink" data-id="element-217" data-mp="3kzt7pqlyl8mt">
                  <CheckIcon size={14} className="mt-1 flex-shrink-0 text-success" strokeWidth={3} data-id="element-218" data-mp="3pv8ig9oo6of0" />
                  <span data-id="element-219" data-mp="3fylyro82y3ek">{feature}</span>
                </li>)}
            </ul>

            <div className="mt-auto pt-5" data-id="element-220" data-mp="2xbmuue5op7vf">
              <p className="text-xs uppercase tracking-wide text-ink-subtle" data-id="element-221" data-mp="2sc9yn2sxaog6">
                Valor de referencia{' '}
                <span className="line-through" data-id="element-222" data-mp="36c1jnnhux53o">{plan.listPrice}</span>
              </p>
              <p className="mt-1 flex items-baseline gap-2" data-id="element-223" data-mp="31c6tjm5wojjo">
                <span className={`font-display text-4xl font-black ${plan.recommended ? 'text-accent' : 'text-ink'}`} data-id="element-224" data-mp="31eszxih28t0b">
                  {plan.price}
                </span>
                <span className="text-base font-semibold text-ink-muted" data-id="element-225" data-mp="3p2ix6ku4bu4g">
                  ARS
                </span>
              </p>
              <CtaButton href={plan.href} external size="lg" variant={plan.recommended ? 'primary' : 'secondary'} className="mt-4" data-id="element-226" data-mp="3l17ekz9nw95r">
                {plan.cta}
              </CtaButton>
            </div>
          </Reveal>)}
      </div>
    </section>;
}